import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
// import { notification } from 'antd'
import 'antd/dist/antd.css';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';

export class DeviceTypeStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      deviceTypes: [],
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
      categories: [],
      category: null,
    });
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.deviceTypes = [];
  }

  async setData(task, data, getDeviceType = true) {
    this[task] = data;
    if (getDeviceType) {
      this.getDeviceTypeList(this.offset, this.limit, this.search, this.sort, this.order);
    }
  }

  async getDeviceTypeList(offset = 0, limit = 15, search = null, sort = null, order = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/deviceversion`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const deviceTypes = res.body || {};
        return (this.deviceTypes = deviceTypes);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getCategory() {
    try {
      let url = `${config.api.url}/${config.api.version}/deviceversion/category/list`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let categories = res.body || [];
        const data = categories.map((item) => {
          let list = {};
          if (item === 'AIRNODE') {
            list.label = 'AiR';
            list.value = item;
          } else if (item === 'EMERGENCY_BUTTON') {
            list.label = 'Emergency Button';
            list.value = item;
          } else if (item === 'BEACON_TAG') {
            list.label = 'Beacon Tag';
            list.value = item;
          }
          return list;
        });
        // categories = categories.map((item) => ({
        //   label: item,
        //   value: item,
        // }));
        return (this.categories = data);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteDeviceType(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/deviceversion/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteFile(path) {
    try {
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/upload/remove`, {
          body: { path },
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res) {
        return true;
      } else {
        throw new Error(res.body.message || 'Error when delete file.');
      }
    } catch (err) {
      console.log('deleteFile ===> ', err);
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 1000);
      }
      return false;
    }
  }

  async updateDeviceType(data, task = null) {
    this.loading = true;
    try {
      const detail = {
        id: data.id,
        name: data.name,
        manufacturer: data.manufacturer,
        description: data.description,
        contactPerson: data.contactPerson,
        address: data.address,
        tel: data.tel,
        email: data.email,
        imgUrl: data.imgUrl,
        type: data.type,
        category: data.category,
        property: JSON.stringify(data.property),
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/deviceversion/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        // notification.success({
        //   message: `Success`,
        //   description: `Device Type has been update successfully`,
        //   top: '100px',
        // });
        // if(task !== 'delete'){
        //   window.location.href = '/app/devicetype'
        //   this.getDeviceTypeList()
        // }
        // return true;
        return res;
      }
    } catch (err) {
      // notification.error({
      //   message: `Update fail`,
      //   description: err.error.message,
      //   top: '100px'
      // });
      // if (err.statusCode === 401) {
      //   setTimeout(() => {
      //     removeToken('id_token')
      //     window.location.href = '/login'
      //   }, 1000)
      // }
      // return false;
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createDeviceType(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        manufacturer: data.manufacturer,
        description: data.description,
        contactPerson: data.contactPerson,
        address: data.address,
        tel: data.tel,
        email: data.email,
        imgUrl: data.imgUrl,
        type: data.type,
        category: data.category,
        property: JSON.stringify(data.property),
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/deviceversion`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async findById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/deviceversion/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const deviceTypes = res.body || {};
        return (this.deviceTypes = deviceTypes);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new DeviceTypeStore();
